'use client'
import React, { useState } from 'react';

const SocialMediaIndustries = ({ color, textcolor, active, activetext }) => {
  const [activeTab, setActiveTab] = useState('first');

  return (
    <section className={`${color} text-${textcolor} mt-20`}>
      <div className="container mt-5">
        <div className="text-center">
          <h2 className="sec-subtile-6">IT Solutions for Social Media Industry</h2>
        </div>
        <h3 className="text-center py-3">Comprehensive IT Solutions for Social Media Platforms</h3>
        <p className="text-center py-3">
          JBcodeapp offers end-to-end IT solutions tailored to social media platforms, helping you improve scalability, engagement, and data security.
        </p>
        <div className="row mt-5">
          {/* Tab section */}
          <div className="col-md-3 col-sm-12 py-2">
            <div className="d-flex flex-column align-items-center  h-100">

              <div className="d-block d-sm-none overflow-x-auto whitespace-nowrap w-100">
                <button
                  className={`px-4 py-2 border border-gray-500 rounded-md mb-2 ml-2 sm:mb-0 ${activeTab === 'first' ? `${active} ${activetext}` : 'hover:bg-white hover:text-black'}`}
                  onClick={() => setActiveTab('first')}
                >
                  Social Media App Development
                </button>
                <button
                  className={`px-4 py-2 border border-gray-500 rounded-md mb-2 ml-2 sm:mb-0 ${activeTab === 'second' ? `${active} ${activetext}` : 'hover:bg-white hover:text-black'}`}
                  onClick={() => setActiveTab('second')}
                >
                  Real-Time Messaging & Communication
                </button>
                <button
                  className={`px-4 py-2 border border-gray-500 rounded-md mb-2 ml-2 sm:mb-0 ${activeTab === 'third' ? `${active} ${activetext}` : 'hover:bg-white hover:text-black'}`}
                  onClick={() => setActiveTab('third')}
                >
                  Social Media Content Management System (CMS)
                </button>
                <button
                  className={`px-4 py-2 border border-gray-500 rounded-md mb-2 ml-2 sm:mb-0 ${activeTab === 'four' ? `${active} ${activetext}` : 'hover:bg-white hover:text-black'}`}
                  onClick={() => setActiveTab('four')}
                >
                  User Analytics & Behavioral Insights
                </button>
                <button
                  className={`px-4 py-2 border border-gray-500 rounded-md mb-2 ml-2 sm:mb-0 ${activeTab === 'six' ? `${active} ${activetext}` : 'hover:bg-white hover:text-black'}`}
                  onClick={() => setActiveTab('five')}
                >
                  Cloud-Based Scalability Solutions
                </button>
                <button
                  className={`px-4 py-2 border border-gray-500 rounded-md mb-2 ml-2 sm:mb-0 ${activeTab === 'six' ? `${active} ${activetext}` : 'hover:bg-white hover:text-black'}`}
                  onClick={() => setActiveTab('six')}
                >
                  Advanced Security & Privacy Solutions
                </button>
              </div>

              <div className="d-none d-sm-flex flex-column ">
                <button
                  className={`px-4 py-2 border border-gray-500 rounded-md mb-2 sm:mb-0 ${activeTab === 'first' ? `${active} ${activetext}` : 'hover:bg-white hover:text-black'}`}
                  onClick={() => setActiveTab('first')}
                >
                  Social Media App Development
                </button>
                <button
                  className={`px-4 py-2 border border-gray-500 rounded-md mb-2 sm:mb-0 ${activeTab === 'second' ? `${active} ${activetext}` : 'hover:bg-white hover:text-black'}`}
                  onClick={() => setActiveTab('second')}
                >
                  Real-Time Messaging & Communication
                </button>
                <button
                  className={`px-4 py-2 border border-gray-500 rounded-md mb-2 sm:mb-0 ${activeTab === 'third' ? `${active} ${activetext}` : 'hover:bg-white hover:text-black'}`}
                  onClick={() => setActiveTab('third')}
                >
                  Social Media Content Management System (CMS)
                </button>
                <button
                  className={`px-4 py-2 border border-gray-500 rounded-md mb-2 sm:mb-0 ${activeTab === 'four' ? `${active} ${activetext}` : 'hover:bg-white hover:text-black'}`}
                  onClick={() => setActiveTab('four')}
                >
                  User Analytics & Behavioral Insights
                </button>
                <button
                  className={`px-4 py-2 border border-gray-500 rounded-md mb-2 ml-2 sm:mb-0 ${activeTab === 'five' ? `${active} ${activetext}` : 'hover:bg-white hover:text-black'}`}
                  onClick={() => setActiveTab('five')}
                >
                  Cloud-Based Scalability Solutions
                </button>
                <button
                  className={`px-4 py-2 border border-gray-500 rounded-md mb-2 ml-2 sm:mb-0 ${activeTab === 'six' ? `${active} ${activetext}` : 'hover:bg-white hover:text-black'}`}
                  onClick={() => setActiveTab('six')}
                >
                  Advanced Security & Privacy Solutions
                </button>
              </div>
            </div>
          </div>


          {/* Icon section */}
          <div className="col-md-9 col-sm-12 ">
            <div className="-brand__list -showcase-mixitup mt-3">
              {/* First Tab: EMR Solutions */}
              {activeTab === 'first' && (
                <>
                  <section>
                    <div className="row">
                      <div className="col-12 text-center">
                        <h3 className="mb-3">Social Media App Development</h3>
                        <p>
                          Launch a highly responsive and user-friendly social media app that keeps users engaged and coming back.
                        </p>
                      </div>
                    </div>
                    <div className="container g-0 mt-[40px] pb-0">
                      <div className="row">
                        <div className="col-xxl-4 col-xl-4 col-lg-4 col-md-4 p-3 mb-3 rounded-lg">
                          <h4 className="workflow__title-6">Profile Management</h4>
                          <p>Secure user profile creation and customization.</p>
                        </div>
                        <div className="col-xxl-4 col-xl-4 col-lg-4 col-md-4 p-3 mb-3 rounded-lg">
                          <h4 className="workflow__title-6">Content Sharing</h4>
                          <p>Enable seamless sharing of multimedia content.</p>
                        </div>
                        <div className="col-xxl-4 col-xl-4 col-lg-4 col-md-4 p-3 mb-3 rounded-lg">
                          <h4 className="workflow__title-6">Notification Systems</h4>
                          <p>Keep users updated with real-time notifications.</p>
                        </div>
                        <div className="col-xxl-4 col-xl-4 col-lg-4 col-md-4 p-3 mb-3 rounded-lg">
                          <h4 className="workflow__title-6">Privacy Controls</h4>
                          <p>Offer advanced privacy settings for users.</p>
                        </div>
                        <div className="col-xxl-4 col-xl-4 col-lg-4 col-md-4 p-3 mb-3 rounded-lg">
                          <h4 className="workflow__title-6">User Analytics</h4>
                          <p>Track user engagement and behavior.</p>
                        </div>
                        <div className="col-xxl-4 col-xl-4 col-lg-4 col-md-4 p-3 mb-3 rounded-lg">
                          <h4 className="workflow__title-6">Push Notifications</h4>
                          <p>Boost engagement with personalized notifications.</p>
                        </div>
                      </div>
                    </div>
                  </section>
                </>
              )}

              {/* Second Tab: Telemedicine Solutions */}
              {activeTab === 'second' && (
                <>
                  <section>
                    <div className="row">
                      <div className="col-12 text-center">
                        <h3 className="mb-3">Real-Time Messaging & Communication</h3>
                        <p>
                          Enhance communication between users with real-time messaging and secure chat functionalities.
                        </p>
                      </div>
                    </div>
                    <div className="container g-0 mt-[40px] pb-0">
                      <div className="row">
                        <div className="col-xxl-4 col-xl-4 col-lg-4 col-md-4 p-3 mb-3 rounded-lg">
                          <h4 className="workflow__title-6">Direct Messaging</h4>
                          <p>Real-time messaging with advanced encryption.</p>
                        </div>
                        <div className="col-xxl-4 col-xl-4 col-lg-4 col-md-4 p-3 mb-3 rounded-lg">
                          <h4 className="workflow__title-6">Group Chat</h4>
                          <p>Create and manage group conversations effortlessly.</p>
                        </div>
                        <div className="col-xxl-4 col-xl-4 col-lg-4 col-md-4 p-3 mb-3 rounded-lg">
                          <h4 className="workflow__title-6">Voice & Video Calls</h4>
                          <p>Enable high-quality voice and video communication.</p>
                        </div>
                        <div className="col-xxl-4 col-xl-4 col-lg-4 col-md-4 p-3 mb-3 rounded-lg">
                          <h4 className="workflow__title-6">Media Sharing</h4>
                          <p>Share images, videos, and files in chats.</p>
                        </div>
                        <div className="col-xxl-4 col-xl-4 col-lg-4 col-md-4 p-3 mb-3 rounded-lg">
                          <h4 className="workflow__title-6">Push Notifications</h4>
                          <p>Notify users instantly about new messages.</p>
                        </div>
                        <div className="col-xxl-4 col-xl-4 col-lg-4 col-md-4 p-3 mb-3 rounded-lg">
                          <h4 className="workflow__title-6">Emojis & Stickers</h4>
                          <p>Enrich conversations with interactive emojis and stickers.</p>
                        </div>
                      </div>
                    </div>
                  </section>
                </>
              )}

              {/* Third Tab: HMS Solutions */}
              {activeTab === 'third' && (
                <>
                  <section>
                    <div className="row">
                      <div className="col-12 text-center">
                        <h3 className="mb-3">Social Media Content Management System (CMS)</h3>
                        <p>
                          Streamline content creation, management, and publishing for social media platforms.
                        </p>
                      </div>
                    </div>
                    <div className="container g-0 mt-[40px] pb-0">
                      <div className="row">
                        <div className="col-xxl-4 col-xl-4 col-lg-4 col-md-4 p-3 mb-3 rounded-lg">
                          <h4 className="workflow__title-6">Content Scheduling</h4>
                          <p>Automate content publishing with scheduling tools.</p>
                        </div>
                        <div className="col-xxl-4 col-xl-4 col-lg-4 col-md-4 p-3 mb-3 rounded-lg">
                          <h4 className="workflow__title-6">Multimedia Management</h4>
                          <p>Manage video, images, and text content easily.</p>
                        </div>
                        <div className="col-xxl-4 col-xl-4 col-lg-4 col-md-4 p-3 mb-3 rounded-lg">
                          <h4 className="workflow__title-6">User-Generated Content</h4>
                          <p>Moderate and display user-generated content.</p>
                        </div>
                        <div className="col-xxl-4 col-xl-4 col-lg-4 col-md-4 p-3 mb-3 rounded-lg">
                          <h4 className="workflow__title-6">Content Analytics</h4>
                          <p>Get insights into post performance and engagement.</p>
                        </div>
                        <div className="col-xxl-4 col-xl-4 col-lg-4 col-md-4 p-3 mb-3 rounded-lg">
                          <h4 className="workflow__title-6">Role-Based Access Control</h4>
                          <p>Manage permissions for different content creators.</p>
                        </div>
                        <div className="col-xxl-4 col-xl-4 col-lg-4 col-md-4 p-3 mb-3 rounded-lg">
                          <h4 className="workflow__title-6">Content Recommendations</h4>
                          <p>Personalize user feeds with smart recommendations.</p>
                        </div>
                      </div>
                    </div>
                  </section>
                </>
              )}

              {/* Fourth Tab: HIE Solutions */}
              {activeTab === 'four' && (
                <>
                  <section>
                    <div className="row">
                      <div className="col-12 text-center">
                        <h3 className="mb-3">User Analytics & Behavioral Insights</h3>
                        <p>
                          Gain a deep understanding of your users' preferences and actions through advanced analytics.
                        </p>
                      </div>
                    </div>
                    <div className="container g-0 mt-[40px] pb-0">
                      <div className="row">
                        <div className="col-xxl-4 col-xl-4 col-lg-4 col-md-4 p-3 mb-3 rounded-lg">
                          <h4 className="workflow__title-6">User Engagement <br/>Tracking</h4>
                          <p>Track how users interact with content.</p>
                        </div>
                        <div className="col-xxl-4 col-xl-4 col-lg-4 col-md-4 p-3 mb-3 rounded-lg">
                          <h4 className="workflow__title-6">Content Performance Analysis</h4>
                          <p>Monitor performance of shared posts and media.</p>
                        </div>
                        <div className="col-xxl-4 col-xl-4 col-lg-4 col-md-4 p-3 mb-3 rounded-lg">
                          <h4 className="workflow__title-6">Behavioral <br/>Segmentation</h4>
                          <p>Segment users based on their activities and preferences.</p>
                        </div>
                        <div className="col-xxl-4 col-xl-4 col-lg-4 col-md-4 p-3 mb-3 rounded-lg">
                          <h4 className="workflow__title-6">Real-Time Analytics</h4>
                          <p>Receive instant insights into user behavior.</p>
                        </div>
                        <div className="col-xxl-4 col-xl-4 col-lg-4 col-md-4 p-3 mb-3 rounded-lg">
                          <h4 className="workflow__title-6">A/B Testing</h4>
                          <p>Optimize content with A/B testing of different formats.</p>
                        </div>
                        <div className="col-xxl-4 col-xl-4 col-lg-4 col-md-4 p-3 mb-3 rounded-lg">
                          <h4 className="workflow__title-6">Predictive Analytics</h4>
                          <p>Use AI-driven insights to predict future trends.</p>
                        </div>
                      </div>
                    </div>
                  </section>
                </>
              )}

              {/* Five Tab: HIE Solutions */}
              {activeTab === 'five' && (
                <>
                  <section>
                    <div className="row">
                      <div className="col-12 text-center">
                        <h3 className="mb-3">Cloud-Based Scalability Solutions</h3>
                        <p>
                          Seamlessly scale your social media platform to handle growing traffic and user base.
                        </p>
                      </div>
                    </div>
                    <div className="container g-0 mt-[40px] pb-0">
                      <div className="row">
                        <div className="col-xxl-4 col-xl-4 col-lg-4 col-md-4 p-3 mb-3 rounded-lg">
                          <h4 className="workflow__title-6">Auto-Scaling Infrastructure</h4>
                          <p>Automatically scale servers based on traffic demands.</p>
                        </div>
                        <div className="col-xxl-4 col-xl-4 col-lg-4 col-md-4 p-3 mb-3 rounded-lg">
                          <h4 className="workflow__title-6">Cloud Hosting</h4>
                          <p>Leverage the power of the cloud for seamless user experience.</p>
                        </div>
                        <div className="col-xxl-4 col-xl-4 col-lg-4 col-md-4 p-3 mb-3 rounded-lg">
                          <h4 className="workflow__title-6">Data Replication</h4>
                          <p>Ensure real-time data backups and redundancy.</p>
                        </div>
                        <div className="col-xxl-4 col-xl-4 col-lg-4 col-md-4 p-3 mb-3 rounded-lg">
                          <h4 className="workflow__title-6">Load Balancing</h4>
                          <p>Distribute traffic efficiently to avoid server overload.</p>
                        </div>
                        <div className="col-xxl-4 col-xl-4 col-lg-4 col-md-4 p-3 mb-3 rounded-lg">
                          <h4 className="workflow__title-6">CDN Integration</h4>
                          <p>Improve global user access with Content Delivery Networks.</p>
                        </div>
                        <div className="col-xxl-4 col-xl-4 col-lg-4 col-md-4 p-3 mb-3 rounded-lg">
                          <h4 className="workflow__title-6">Server Monitoring</h4>
                          <p>Real-time monitoring of server health and performance.</p>
                        </div>
                      </div>
                    </div>
                  </section>
                </>
              )}

              {/* Six Tab: HIE Solutions */}
              {activeTab === 'six' && (
                <>
                  <section>
                    <div className="row">
                      <div className="col-12 text-center">
                        <h3 className="mb-3">Advanced Security & Privacy Solutions</h3>
                        <p>
                          Implement top-tier security protocols to protect user data and platform integrity.
                        </p>
                      </div>
                    </div>
                    <div className="container g-0 mt-[40px] pb-0">
                      <div className="row">
                        <div className="col-xxl-4 col-xl-4 col-lg-4 col-md-4 p-3 mb-3 rounded-lg">
                          <h4 className="workflow__title-6">End-to-End Encryption</h4>
                          <p>Secure messaging and data transfers with encryption.</p>
                        </div>
                        <div className="col-xxl-4 col-xl-4 col-lg-4 col-md-4 p-3 mb-3 rounded-lg">
                          <h4 className="workflow__title-6">Two-Factor Authentication</h4>
                          <p>Add an extra layer of security for user logins.</p>
                        </div>
                        <div className="col-xxl-4 col-xl-4 col-lg-4 col-md-4 p-3 mb-3 rounded-lg">
                          <h4 className="workflow__title-6">Data Privacy Compliance</h4>
                          <p>Ensure compliance with data protection regulations like GDPR.</p>
                        </div>
                        <div className="col-xxl-4 col-xl-4 col-lg-4 col-md-4 p-3 mb-3 rounded-lg">
                          <h4 className="workflow__title-6">Fraud Detection</h4>
                          <p>Monitor and detect fraudulent activity in real time.</p>
                        </div>
                        <div className="col-xxl-4 col-xl-4 col-lg-4 col-md-4 p-3 mb-3 rounded-lg">
                          <h4 className="workflow__title-6">Access Control Management</h4>
                          <p>Manage user access with role-based permissions.</p>
                        </div>
                        <div className="col-xxl-4 col-xl-4 col-lg-4 col-md-4 p-3 mb-3 rounded-lg">
                          <h4 className="workflow__title-6">Regular Security Audits</h4>
                          <p>Identify vulnerabilities with routine security checks.</p>
                        </div>
                      </div>
                    </div>
                  </section>
                </>
              )}
            </div>
          </div>
        </div>
      </div>
    </section>

  );
};

export default SocialMediaIndustries;
